import React, { Component } from "react";

import moment from "moment";
import "./style.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import ProcessingWithDots from "../ProcessingWithDots";


class DayFlux extends Component {


	render() {
		const { day, flux, isLast, manualColours, avg } = this.props;

		// console.log('[DayFlux] day: ', day);
		// console.log('[DayFlux] flux: ', flux);
	
		const _date = moment(day, "YYYY-MM-DD");
		const date = _date.format("MMM Do");
		const dayName = _date.format("ddd").toUpperCase();
		const bgColours = manualColours[Math.floor(flux)];

		// console.log('[DayFlux] average: ', avg);

		const divStyle = {
			backgroundColor: bgColours, // Set the background color based on bgColours
		};

		return (
			<div
				className={"bl-day-flux " + (isLast ? "bl-day-flux-big" : "")}
			>

				<div className="bl-day-flux-date-parent">
					<div className="bl-day-flux-day">{dayName}</div>
					<div className="bl-day-flux-date">{date}</div>
				</div>
				<div className="bl-day-flux-number is-this-it" style={divStyle}>

					{moment(day, "YYYY-MM-DD").isSame(moment().startOf("day"), "day") ? (
						flux === 'No result' ? (
							<div style={{ color: 'red' }}><ProcessingWithDots /></div> // Display "Processing" for today
						) : (
							flux // Display the flux value for today if available
						)
					) : flux === 'No result' ? (
						<div>
							<FontAwesomeIcon icon={faCircleExclamation} size="2x" style={{ color: 'red', fontSize: '10px' }} /> No result
						</div> // Display "No result" for past days
					) : (
						flux // Display the flux value for past days
					)}
					{/* Add "Avg." text conditionally */}
					{(avg >= 7 || avg === 0 || avg === 0.56 || avg === "No result") && <div className="avg-indicator">Avg</div>}
				</div>
				
			</div>
		);
	}

}

export default DayFlux;
